export var QuestCategory;
(function (QuestCategory) {
    QuestCategory[QuestCategory["Main"] = 9] = "Main";
    QuestCategory[QuestCategory["Adventure"] = 27] = "Adventure";
})(QuestCategory || (QuestCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/QuestCategory.ts
// module id = 2686
// module chunks = 3